import Vue from 'vue'
Vue.filter('booleanText', function (value) {
  return value ? 'Yes' : 'No'
})

Vue.filter('booleanEnabledText', function (value) {
  return value ? 'Enabled' : 'Disabled'
})

Vue.filter('dateFormat', function (value) {
  if (!value) return ''
  //return value.substring(0, 10)
  return value
})

Vue.filter('capitalize', function (value) {
  if (!value) return ''
  value = value.toString()
  return value.charAt(0).toUpperCase() + value.slice(1)
})

Vue.filter('numberFormat', function (value) {
  if (!value) return ''
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
})